// This file was automatically generated from newDialogButton.html.
// Please don't edit this file by hand.

goog.provide('el8.template.newDialogButton');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.newDialogButton.button = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ButtonItem"><button type="button" class="el8button ', (opt_data.isPrimary) ? 'el8PrimaryButton ebs-btn ebs-btn-primary' : (opt_data.isDangerous) ? 'el8RedButton ebs-btn ebs-btn-dangerous' : 'el8SecondaryButton ebs-btn ebs-btn-default', '" name="', soy.$$escapeHtml(opt_data.name), '" ', (opt_data.testId) ? 'data-testid="' + soy.$$escapeHtml(opt_data.testId) + '"' : '', '>', soy.$$escapeHtml(opt_data.caption), (opt_data.isDropdown) ? '<span class="el8ButtonDropdownArrow"></span>' : '', '</button></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.newDialogButton.buttons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8DialogButtonContainer"><ul class="el8ButtonContainer">');
  var buttonList157 = opt_data.buttons;
  var buttonListLen157 = buttonList157.length;
  for (var buttonIndex157 = 0; buttonIndex157 < buttonListLen157; buttonIndex157++) {
    var buttonData157 = buttonList157[buttonIndex157];
    el8.template.newDialogButton.button(buttonData157, output);
  }
  output.append('</ul><span class="tabcatcher" tabindex="0"></span></div>');
  if (!opt_sb) return output.toString();
};
